import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { LabelPosition, LabelAlignment } from '../enums';

export enum RoseType {
  Area = 'area',
  Radius = 'radius'
}

export type EchartsNightingalePieFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    tooltipFormat: string;
    roseType: RoseType;
    labelPosition: LabelPosition;
    labelAlignment: LabelAlignment;
};

export interface EchartsNightingalePieChartProps
  extends ChartProps<EchartsNightingalePieFormData> {
  formData: EchartsNightingalePieFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsNightingalePieFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b} : {c} ({d}%)',
  roseType: RoseType.Area,
  labelPosition: LabelPosition.Outer,
  labelAlignment: LabelAlignment.None
};

export interface NightingalePieChartTransformedProps {
  formData: EchartsNightingalePieFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}